import { render, staticRenderFns } from "./PersonClockIcon.vue?vue&type=template&id=727ca18d&"
import script from "./PersonClockIcon.vue?vue&type=script&lang=ts&"
export * from "./PersonClockIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports